var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16677 5.44832L1.16677 15.552L1.16677 15.5521C1.16677 17.4467 1.16677 18.3937 1.56464 18.9413C1.91169 19.419 2.44519 19.7272 3.03239 19.7889C3.70559 19.8596 4.5259 19.3861 6.16672 18.4388L14.9167 13.387C16.5575 12.4396 17.3781 11.9658 17.6534 11.3474C17.8935 10.808 17.8935 10.1918 17.6534 9.65242C17.3782 9.0343 16.5583 8.56092 14.9189 7.61442L14.9167 7.61318L6.16672 2.56136C4.5259 1.61403 3.70559 1.14051 3.03239 1.21126C2.44519 1.27298 1.91169 1.58117 1.56464 2.05884C1.16677 2.60646 1.16677 3.55363 1.16677 5.44819L1.16677 5.44832Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.b2eeb95396d9f5a88442a6b1fce6296d.svg";
export { ForwardRef as ReactComponent };